import {
    Medication
} from 'one-state-medication/src/medication';
import { formatIso } from 'one-util-date';

export const sortFunction = (a: Medication, b: Medication) => {
    const dateA = new Date(a.startdate);
    const dateB =new Date(b.startdate);
    return dateB.getTime() - dateA.getTime();
}

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Medication Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    // let result: Medication[] = [];
    let result :any = {
        medication:[],
        error:undefined
    }

    const { log,settings } = context;
    const {uisettings: {dateformat}} = settings
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
    }

    if (response && response.length > 0) {
        const rs = response;
        let medicationarray: Medication[] = [];
        rs.map((ele: any) => {
            if(ele?.medications && ele?.medications.length > 0){
                ele.medications.map ((medicationdata: any) => {
                    let medicationobj : Medication ={
                        medicationId: "",
                        name :"",
                        patientsig:"",
                        startDate:"",
                        endDate:"",
                        refillsremaining:""
                    };
                    medicationobj.medicationId = medicationdata[0]?.medication_id;
                    medicationobj.name = medicationdata[0]?.name;
                    medicationobj.patientsig = medicationdata[0]?.patientsig;
                    medicationobj.startdate = medicationdata[0]?.startDate ? formatIso(medicationdata[0].startDate, dateformat) : "";
                    medicationobj.enddate = medicationdata[0]?.endDate ? formatIso(medicationdata[0].endDate, dateformat) : "";
                    medicationobj.refillsremaining = medicationdata[0]?.refills_remaining;
                    medicationarray.push(medicationobj);
                })
            }
        });
        result.medication = medicationarray;
    }
    log.debug(
        "ccw-gadget,medication-epic",
        "medication-epic transforamtion response ", {
        result
    });
    result.medication.sort(sortFunction);
    return result;
}